import React from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Modal } from "antd";
import { PoweroffOutlined, UserOutlined, LogoutOutlined, LockOutlined } from "@ant-design/icons";
import { App } from "context/AppContext";
import { Link } from "react-router-dom";
import { emp } from "api/endpoints";
import "./style.css";

const logoutMenuStyle = {
  background: "#7a8994",
  color: "#fff",
  margin: 0,
  padding: 0,
};

const menuContainerStyle = {
  position: "relative",
  display: "block",
  height: "100%",
  boxShadow: "1px 6px 5px #ccc",
  color: "#7a8994",
};

const ProfileMenu = () => {
  const navigate = useNavigate();
  const { userData, logout } = App();

  const onLogout = () => {
    const logoutModal = Modal.confirm({
      title: "Системээс гарах",
      content: "Та системээс гарах бол ОК товчийг дарна уу!",
      okText: "ОК",
      cancelText: "Цуцлах",
      // centered: true,
      icon: <LogoutOutlined />,
      onCancel: () => {},
      onOk: async () => {
        logoutModal.update({
          okButtonProps: { disabled: true },
          cancelButtonProps: { disabled: true },
        });
        logout();
      },
    });
  };

  return (
    <div style={menuContainerStyle}>
      <span className="arrow-top" />
      <Menu style={{ paddingBottom: 0, marginBottom: 0, position: "relative" }}>
        <Menu.Item key={"profile"} icon={<UserOutlined />}>
          <Link to={`${emp.emp}/${userData?.UserId}?tab=main`}>Профайл</Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key={"password"} icon={<LockOutlined />}>
          <Link to={`${emp.emp}/${userData?.UserId}?tab=password`}>Нууц үг солих</Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          key="logout"
          onClick={() => {
            onLogout(navigate);
          }}
          style={logoutMenuStyle}
        >
          <span className="logout-btn">
            {"Гарах"}
            <PoweroffOutlined />
          </span>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default ProfileMenu;
